<template>
    <div>
        <StrategyItem :data="data" />
    </div>
</template>

<script>
import StrategyItem from "../hListItems/StrategyItem";
export default {
    name: "GuidesItem",
    props: ["data"],
    components: {
        StrategyItem
    },
    data() {
        return {};
    },
    computed: {},
    watch: {},
    methods: {}
};
</script>

<style lang="scss" scoped></style>
